import { useState } from 'react';
import { FriendLocation } from '../../../types';

/**
 * Hook to manage map search functionality (friends and places)
 */
export const useMapSearch = () => {
  // Search bar visibility
  const [showSearchBar, setShowSearchBar] = useState(window.innerWidth > 768);

  // Search query and type
  const [searchQuery, setSearchQuery] = useState('');
  const [searchType] = useState<'friends' | 'places'>('friends');

  // Search results
  const [friendResults, setFriendResults] = useState<FriendLocation[]>([]);
  const [placeResults, setPlaceResults] = useState<any[]>([]);
  const [isSearching, setIsSearching] = useState(false);

  // Selected places
  const [selectedPlace, setSelectedPlace] = useState<any>(null);
  const [currentPositionPlace, setCurrentPositionPlace] = useState<any>(null);
  const [selectedMapPlace, setSelectedMapPlace] = useState<any>(null);

  return {
    // Search bar
    showSearchBar,
    setShowSearchBar,

    // Search input
    searchQuery,
    setSearchQuery,
    searchType,

    // Results
    friendResults,
    setFriendResults,
    placeResults,
    setPlaceResults,
    isSearching,
    setIsSearching,

    // Selected places
    selectedPlace,
    setSelectedPlace,
    currentPositionPlace,
    setCurrentPositionPlace,
    selectedMapPlace,
    setSelectedMapPlace,
  };
};
